import { TokenIF } from '../types/token/TokenIF';

export const mainnetETH: TokenIF = {
    address: '0x0000000000000000000000000000000000000000',
    chainId: 1,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
    name: 'Ether',
    symbol: 'ETH',
};

export const mainnetUSDC: TokenIF = {
    address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    chainId: 1,
    decimals: 6,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
    name: 'USDCoin',
    symbol: 'USDC',
};

export const blastETH: TokenIF = {
    address: '0x0000000000000000000000000000000000000000',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
    name: 'Ether',
    symbol: 'ETH',
};

export const blastUSDB: TokenIF = {
    address: '0x4300000000000000000000000000000000000003',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://assets-global.website-files.com/65a6baa1a3f8ed336f415cb4/65c67f0ebf2f6a1bd0feb13c_usdb-icon-yellow.png',
    name: 'USDB',
    symbol: 'USDB',
};

export const blastUSDPLUS: TokenIF = {
    address: '0x4fee793d435c6d2c10c135983bb9d6d4fc7b9bbd',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI: '',
    name: 'USD+',
    symbol: 'USD+',
};

export const blastORBIT: TokenIF = {
    address: '0x42E12D42b3d6C4A74a88A61063856756Ea2DB357',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Orbit Protocol',
    symbol: 'ORBIT',
    logoURI: 'https://blastscan.io/token/images/orbit_32.png',
};

export const blastMIA: TokenIF = {
    address: '0xA4C7aA67189EC5623121c6C94Ec757DfeD932D4B',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Mia',
    symbol: 'MIA',
    logoURI: 'https://miablastsoff.com/images/logo.png',
};

export const blastJUICE: TokenIF = {
    address: '0x818a92bc81aad0053d72ba753fb5bc3d0c5c0923',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Juice',
    symbol: 'JUICE',
    logoURI: 'https://miablastsoff.com/images/logo.png',
};

export const blastMIM: TokenIF = {
    address: '0x76DA31D7C9CbEAE102aff34D3398bC450c8374c1',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Magic Internet Money',
    symbol: 'MIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/162.png',
};

export const blastBAG: TokenIF = {
    address: '0xb9dfCd4CF589bB8090569cb52FaC1b88Dbe4981F',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Bag',
    symbol: 'BAG',
    logoURI: 'https://assets.coingecko.com/coins/images/35417/thumb/bag-cg.png',
};

export const blastBEPE: TokenIF = {
    address: '0xB582Dc28968c725D2868130752aFa0c13EbF9b1a',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Blast Pepe',
    symbol: 'BEPE',
    logoURI:
        'https://assets.coingecko.com/coins/images/35658/standard/logo_200.png',
};

export const blastALIEN: TokenIF = {
    address: '0xCa84812E477eE5a96a92328689D8Ce2589aB6FfD',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Alien',
    symbol: 'ALIEN',
    logoURI: '',
};

export const blastBAJA: TokenIF = {
    address: '0x5FE8534a6F96cb01261Bd96e98c17C2c1Cab3204',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Baja',
    symbol: 'BAJA',
    logoURI: '',
};

export const blastESE: TokenIF = {
    address: '0x5FE8534a6F96cb01261Bd96e98c17C2c1Cab3204',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'eesee',
    symbol: 'ESE',
    logoURI: '',
};

export const blastYES: TokenIF = {
    address: '0x20fE91f17ec9080E3caC2d688b4EcB48C5aC3a9C',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Yes',
    symbol: 'YES',
    logoURI: '',
};

export const blastPACM: TokenIF = {
    address: '0x0B4d0ee29857c3961b380d4ec138EA5814E346b9',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'P@cman Blastoff',
    symbol: '$PACM',
    logoURI: '',
};

export const blastWETH: TokenIF = {
    address: '0x4300000000000000000000000000000000000004',
    chainId: 81457,
    decimals: 18,
    fromList: '',
    name: 'Wrapped Ether',
    symbol: 'wETH',
    logoURI: '',
};

export const blastWrsETH: TokenIF = {
    name: 'Wrapped Kelp DAO Restaked ETH',
    address: '0xe7903B1F75C534Dd8159b313d92cDCfbC62cB3Cd',
    symbol: 'wrsETH',
    decimals: 18,
    chainId: 81457,
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29242.png',
};

export const blastEzETH: TokenIF = {
    name: 'Renzo Restaked ETH',
    address: '0x2416092f143378750bb29b79eD961ab195CcEea5',
    symbol: 'ezETH',
    decimals: 18,
    chainId: 81457,
    logoURI: '',
};

export const blastPUMP: TokenIF = {
    address: '0x216A5a1135A9dab49FA9Ad865E0f22FE22b5630A',
    chainId: 81457,
    decimals: 18,
    fromList: '',
    name: 'PUMP',
    symbol: 'PUMP',
    logoURI: '',
};

export const blastSSS: TokenIF = {
    address: '0xfd4D19F9FBb9F730C3C88a21755832BD2455144e',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'Super Sushi Samurai',
    symbol: 'SSS',
    logoURI:
        'https://assets.coingecko.com/coins/images/36139/standard/sss.jpeg',
};

export const blastOLE: TokenIF = {
    address: '0x73c369f61c90f03eb0dd172e95c90208a28dc5bc',
    chainId: 81457,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    name: 'OpenLeverage',
    symbol: 'OLE',
    logoURI: 'https://blastscan.io/token/images/openleverageole_32.png',
};

export const blastSepoliaETH: TokenIF = {
    address: '0x0000000000000000000000000000000000000000',
    chainId: 168587773,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
    name: 'Ether',
    symbol: 'ETH',
};

export const blastSepoliaUSDB: TokenIF = {
    address: '0x4200000000000000000000000000000000000022',
    chainId: 168587773,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://assets-global.website-files.com/65a6baa1a3f8ed336f415cb4/65c67f0ebf2f6a1bd0feb13c_usdb-icon-yellow.png',
    name: 'USDB',
    symbol: 'USDB',
};

export const mainnetWBTC: TokenIF = {
    address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    chainId: 1,
    decimals: 8,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png',
    name: 'Wrapped BTC',
    symbol: 'WBTC',
};

export const mainnetPEPE: TokenIF = {
    address: '0x6982508145454Ce325dDbE47a25d4ec3d2311933',
    chainId: 1,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://assets.coingecko.com/coins/images/29850/large/pepe-token.jpeg?1682922725',
    name: 'Pepe',
    symbol: 'PEPE',
};

export const mainnetSWETH: TokenIF = {
    address: '0xf951e335afb289353dc249e82926178eac7ded78',
    chainId: 1,
    decimals: 18,
    fromList: '',
    logoURI: 'https://etherscan.io/token/images/swellnetwork_32.png',
    name: 'Swell Staked Ether',
    symbol: 'swETH',
};

export const mainnetLIDO: TokenIF = {
    address: '0x5a98fcbea516cf06857215779fd812ca3bef1b32',
    chainId: 1,
    decimals: 18,
    fromList: '',
    logoURI: 'https://etherscan.io/token/images/lido-dao_32.png',
    name: 'Lido DAO Token',
    symbol: 'LDO',
};

export const mainnetLUSD: TokenIF = {
    address: '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
    chainId: 1,
    decimals: 18,
    fromList: '',
    logoURI: 'https://etherscan.io/token/images/liquitylusd_32.png',
    name: 'Liquity USD',
    symbol: 'LUSD',
};

export const mainnetMKR: TokenIF = {
    address: '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2',
    chainId: 1,
    decimals: 18,
    fromList: '',
    logoURI: 'https://etherscan.io/token/images/mkr-etherscan-35.png',
    name: 'Maker',
    symbol: 'MKR',
};

export const mainnetSYN: TokenIF = {
    address: '0x0f2d719407fdbeff09d87557abb7232601fd9f29',
    chainId: 1,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://assets.coingecko.com/coins/images/18024/thumb/syn.png?1635002049',
    name: 'Synapse',
    symbol: 'SYN',
};

export const mainnetDAI: TokenIF = {
    address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    chainId: 1,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png',
    name: 'Dai Stablecoin',
    symbol: 'DAI',
};

export const mainnetRPL: TokenIF = {
    address: '0xd33526068d116ce69f19a9ee46f0bd304f21a51f',
    chainId: 1,
    decimals: 18,
    fromList: '',
    logoURI: 'https://etherscan.io/token/images/Rocketpool_32.png',
    name: 'Rocket Pool',
    symbol: 'RPL',
};

export const mainnetWstETH: TokenIF = {
    address: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    chainId: 1,
    decimals: 18,
    fromList: '',
    logoURI: '',
    name: 'Wrapped liquid staked Ether 2.0',
    symbol: 'wstETH',
};

export const mainnetMATIC: TokenIF = {
    address: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
    chainId: 1,
    decimals: 18,
    fromList: '',
    logoURI: '',
    name: 'Matic Token',
    symbol: 'MATIC',
};

export const mainnetFRAX: TokenIF = {
    address: '0x853d955acef822db058eb8505911ed77f175b99e',
    chainId: 1,
    decimals: 18,
    fromList: '/ambient-token-list.json',
    logoURI: 'https://etherscan.io/token/images/fraxfinanceeth2_32.png',
    name: 'Frax',
    symbol: 'FRAX',
};

export const mainnetUSDT: TokenIF = {
    address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    chainId: 1,
    decimals: 6,
    fromList: 'https://tokens.coingecko.com/uniswap/all.json',
    logoURI: 'https://assets.coingecko.com/coins/images/325/thumb/Tether.png',
    name: 'Tether',
    symbol: 'USDT',
};

export const sepoliaETH: TokenIF = {
    name: 'Native Ether',
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'ETH',
    decimals: 18,
    chainId: 11155111,
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
    fromList: '/ambient-token-list.json',
};

export const sepoliaUSDC: TokenIF = {
    name: 'USDCoin',
    address: '0x60bBA138A74C5e7326885De5090700626950d509',
    symbol: 'USDC',
    decimals: 6,
    chainId: 11155111,
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
    fromList: '/ambient-token-list.json',
};

export const sepoliaWBTC: TokenIF = {
    name: 'Wrapped BTC',
    address: '0xCA97CC9c1a1dfA54A252DaAFE9b5Cd1E16C81328',
    symbol: 'WBTC',
    decimals: 8,
    chainId: 11155111,
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png',
    fromList: '/ambient-token-list.json',
};

export const scrollSepoliaWBTC: TokenIF = {
    name: 'Wrapped BTC',
    address: '0xb3B942b6d4a4858838aAb8f94DdaEdd479CD1594',
    symbol: 'WBTC',
    decimals: 8,
    chainId: 534351,
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png',
    fromList: '/ambient-token-list.json',
};

export const scrollETH: TokenIF = {
    name: 'Native Ether',
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'ETH',
    decimals: 18,
    chainId: 534352,
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
};

export const scrollWstETH: TokenIF = {
    name: 'Wrapped liquid staked Ether 2.0',
    address: '0xf610A9dfB7C89644979b4A0f27063E9e7d7Cda32',
    symbol: 'wstETH',
    decimals: 18,
    chainId: 534352,
    logoURI: 'https://scroll-tech.github.io/token-list/data/wstETH/logo.svg',
};

export const scrollWrsETH: TokenIF = {
    name: 'Wrapped Kelp DAO Restaked ETH',
    address: '0xa25b25548b4c98b0c7d3d27dca5d5ca743d68b7f',
    symbol: 'wrsETH',
    decimals: 18,
    chainId: 534352,
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29242.png',
};

export const scrollSTONE: TokenIF = {
    name: 'StakeStone Ether',
    address: '0x80137510979822322193FC997d400D5A6C747bf7',
    symbol: 'STONE',
    decimals: 18,
    chainId: 534352,
    logoURI: '',
};

export const scrollUniETH: TokenIF = {
    name: 'Universal ETH',
    address: '0x15eefe5b297136b8712291b632404b66a8ef4d25',
    symbol: 'uniETH',
    decimals: 18,
    chainId: 534352,
    logoURI:
        'https://assets.coingecko.com/coins/images/28477/standard/uniETH_200.png?1696527471',
};

export const scrollRocketPoolETH: TokenIF = {
    name: 'Rocket Pool ETH',
    address: '0x53878B874283351D26d206FA512aEcE1Bef6C0dD',
    symbol: 'rETH',
    decimals: 18,
    chainId: 534352,
    logoURI: '',
};

export const scrollPxETH: TokenIF = {
    name: 'Pirex Ether OFT',
    address: '0x9e0d7d79735e1c63333128149c7b616a0dc0bbdb',
    symbol: 'pxETH',
    decimals: 18,
    chainId: 534352,
    logoURI: '',
};

export const scrollWrappedETH: TokenIF = {
    name: 'Wrapped Ether',
    address: '0x5300000000000000000000000000000000000004',
    symbol: 'wETH',
    decimals: 18,
    chainId: 534352,
    logoURI: '',
};

export const scrollBalancer: TokenIF = {
    name: 'Balancer',
    address: '0x6a28e90582c583fcd3347931c544819C31e9D0e0',
    symbol: 'BAL',
    decimals: 18,
    chainId: 534352,
    logoURI: '',
};

export const scrollDODO: TokenIF = {
    name: 'DODO bird',
    address: '0x912aB742e1ab30ffa87038C425F9Bc8ED12B3EF4',
    symbol: 'DODO',
    decimals: 18,
    chainId: 534352,
    logoURI:
        'https://assets.coingecko.com/coins/images/12651/standard/dodo_logo.png?1696512458',
};

export const scrollUSDC: TokenIF = {
    name: 'USDCoin',
    address: '0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4',
    symbol: 'USDC',
    decimals: 6,
    chainId: 534352,
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
};

export const scrollAxlUSDC: TokenIF = {
    name: 'Axelar Wrapped USDC',
    address: '0xEB466342C4d449BC9f53A865D5Cb90586f405215',
    symbol: 'axlUSDC',
    decimals: 6,
    chainId: 534352,
    logoURI: '',
};

export const scrollDAI: TokenIF = {
    name: 'Dai Stablecoin',
    address: '0xcA77eB3fEFe3725Dc33bccB54eDEFc3D9f764f97',
    symbol: 'DAI',
    decimals: 18,
    chainId: 534352,
    logoURI:
        'https://tokens.1inch.io/0x6b175474e89094c44da98b954eedeac495271d0f.png',
};
export const scrollKNC: TokenIF = {
    name: 'Kyber Network Crystal v2',
    address: '0x608ef9a3bffe206b86c3108218003b3cfbf99c84',
    symbol: 'KNC',
    decimals: 18,
    chainId: 534352,
    logoURI: 'https://scrollscan.com/token/images/kybernetworkknc_32.png',
};

export const scrollUSDT: TokenIF = {
    chainId: 534352,
    address: '0xf55BEC9cafDbE8730f096Aa55dad6D22d44099Df',
    name: 'Tether',
    symbol: 'USDT',
    decimals: 6,
    logoURI: 'https://scroll-tech.github.io/token-list/data/USDT/logo.svg',
};

export const scrollWBTC: TokenIF = {
    chainId: 534352,
    address: '0x3C1BCa5a656e69edCD0D4E36BEbb3FcDAcA60Cf1',
    name: 'Wrapped BTC',
    symbol: 'WBTC',
    decimals: 8,
    logoURI: 'https://scroll-tech.github.io/token-list/data/WBTC/logo.svg',
};

export const scrollSepoliaETH: TokenIF = {
    name: 'Native Ether',
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'ETH',
    decimals: 18,
    chainId: 534351,
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
};

export const scrollSepoliaUSDC: TokenIF = {
    name: 'USDCoin',
    address: '0x4D65fB724CEd0CFC6ABFD03231C9CDC2C36A587B',
    symbol: 'USDC',
    decimals: 6,
    chainId: 534351,
    logoURI:
        'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
};

export const defaultTokens: TokenIF[] = [
    mainnetETH,
    mainnetUSDC,
    mainnetWBTC,
    mainnetPEPE,
    mainnetDAI,
    mainnetFRAX,
    mainnetSYN,
    mainnetUSDT,
    mainnetRPL,
    mainnetWstETH,
    mainnetMATIC,
    mainnetSWETH,
    mainnetMKR,
    mainnetLIDO,
    mainnetLUSD,
    blastETH,
    blastWrsETH,
    blastUSDB,
    blastUSDPLUS,
    blastMIA,
    blastMIM,
    blastORBIT,
    blastBAG,
    blastBAJA,
    blastESE,
    blastBEPE,
    blastALIEN,
    blastOLE,
    blastWETH,
    blastEzETH,
    blastPUMP,
    blastYES,
    blastPACM,
    blastSSS,
    blastSepoliaETH,
    blastSepoliaUSDB,
    scrollETH,
    scrollUSDC,
    scrollDODO,
    scrollDAI,
    scrollUSDT,
    scrollKNC,
    scrollBalancer,
    scrollAxlUSDC,
    scrollWBTC,
    scrollRocketPoolETH,
    scrollWrappedETH,
    scrollWstETH,
    scrollWrsETH,
    scrollSTONE,
    scrollUniETH,
    sepoliaETH,
    sepoliaUSDC,
    sepoliaWBTC,
    scrollSepoliaETH,
    scrollSepoliaUSDC,
    scrollSepoliaWBTC,
];
